import React from 'react';

const SectionTitle = props => {

    const { item, span } = styles;

    const renderTitleAddition = () => {
        return (
            <span style={span}>- {props.titleAddition}</span>
        );
    }

    return (
        <div style={item}>
            {props.title} {props.titleAddition ? renderTitleAddition() : null}
        </div>
    );
}

export default SectionTitle;

const styles = {
    item: {
        fontSize: '14px',
        fontWeight: 'bold',
        borderBottom: '3px solid rgb(130,197,234)',
        padding: '5px 10px 5px 10px',
        display: 'inline-block'
    },
    span: {
        fontSize: '13px',
        fontStyle: 'italic'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/SectionTitle.js